import React from 'react'

function ApiContentBlank() {
  return (
    <div className='container p-3 text-center' style={{ marginTop: "7rem" }}>
      <h1 className='display-6'>Coming Soon...</h1>
      <p>Submit API related query through our Contact US form</p>
    </div>
  )
}

export default ApiContentBlank;
